import type { UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';
import type { UseMutationResult } from 'react-query';
import type { ApiResponse } from '../../../util/types/Response';

export function useServerBarcodeValidation<T, K>(
	mutation: UseMutationResult<ApiResponse<K>, unknown, void, unknown>,
	form: UseFormReturnType<T, (values: T) => T>,
) {
	useEffect(() => {
		if (!mutation.data?.isValid) {
			mutation.data?.validationMessages.forEach((v) => {
				if (v.inputIdentifier === 'Barcode') {
					form.setErrors({ barcode: v.validationMessage });
				}
			});
		}
	}, [mutation.data?.validationMessages]);
}
